import { render } from "./contract.vue?vue&type=template&id=04043560&scoped=true"
import script from "./contract.vue?vue&type=script&lang=js"
export * from "./contract.vue?vue&type=script&lang=js"

import "./contract.vue?vue&type=style&index=0&id=04043560&lang=css&scoped=true"

import exportComponent from "/home/runner/work/translation_system/translation_system/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04043560"]])

export default __exports__